import { render, staticRenderFns } from "./SharesAmalgamation.vue?vue&type=template&id=39a6fb8c&scoped=true&"
import script from "./SharesAmalgamation.vue?vue&type=script&lang=js&"
export * from "./SharesAmalgamation.vue?vue&type=script&lang=js&"
import style0 from "./SharesAmalgamation.vue?vue&type=style&index=0&id=39a6fb8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a6fb8c",
  null
  
)

export default component.exports